const CurrencyRupeeCircle = ({ color, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "20"}
      height={size || "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g id="currency-rupee-circle">
        <path
          id="Solid"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99967 0.833496C4.93706 0.833496 0.833008 4.93755 0.833008 10.0002C0.833008 15.0628 4.93706 19.1668 9.99967 19.1668C15.0623 19.1668 19.1663 15.0628 19.1663 10.0002C19.1663 4.93755 15.0623 0.833496 9.99967 0.833496ZM6.24967 5.41683C6.24967 4.95659 6.62277 4.5835 7.08301 4.5835H12.9163C13.3766 4.5835 13.7497 4.95659 13.7497 5.41683C13.7497 5.87707 13.3766 6.25016 12.9163 6.25016H11.3824C11.6162 6.63791 11.7743 7.06399 11.8618 7.50016H12.9163C13.3766 7.50016 13.7497 7.87326 13.7497 8.3335C13.7497 8.79373 13.3766 9.16683 12.9163 9.16683H11.8618C11.7381 9.78377 11.4729 10.3805 11.0525 10.8772C10.6082 11.4019 10.0095 11.7909 9.28058 11.9715L12.1941 14.3552C12.5503 14.6467 12.6028 15.1717 12.3113 15.5279C12.0199 15.8841 11.4949 15.9366 11.1387 15.6452L6.5603 11.8992C6.5515 11.8921 6.54285 11.8848 6.53435 11.8774C6.44794 11.8019 6.38075 11.7122 6.33339 11.6146C6.27976 11.5045 6.24967 11.3809 6.24967 11.2502L6.24968 11.2492C6.24969 11.2213 6.2511 11.1934 6.25392 11.1656C6.27293 10.977 6.35484 10.8069 6.47834 10.6767C6.54544 10.6058 6.62255 10.5491 6.70565 10.507C6.81895 10.4493 6.94726 10.4168 7.08309 10.4168H8.33301C9.01828 10.4168 9.47857 10.1568 9.78043 9.80025C9.93278 9.62031 10.0534 9.40465 10.1377 9.16683H7.08301C6.62277 9.16683 6.24967 8.79373 6.24967 8.3335C6.24967 7.87326 6.62277 7.50016 7.08301 7.50016H10.1377C10.0534 7.26234 9.93278 7.04669 9.78043 6.86674C9.47857 6.51018 9.01828 6.25016 8.33301 6.25016H7.08301C6.62277 6.25016 6.24967 5.87707 6.24967 5.41683Z"
          fill={color || "#697777"}
        />
      </g>
    </svg>
  );
  
};

export default CurrencyRupeeCircle;